import { clsx } from 'clsx';
import React from 'react';
import Text from '../Text/Text.js';
import classes from './FormControlCaption.module.css.js';
import { useFormControlContext } from './_FormControlContext.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';

function FormControlCaption({
  id,
  children,
  sx,
  className
}) {
  const {
    captionId,
    disabled
  } = useFormControlContext();
  return /*#__PURE__*/React.createElement(BoxWithFallback, {
    as: Text,
    id: id !== null && id !== undefined ? id : captionId,
    className: clsx(className, classes.Caption),
    "data-control-disabled": disabled ? '' : undefined,
    sx: sx
  }, children);
}
FormControlCaption.displayName = "FormControlCaption";

export { FormControlCaption };
